module.exports = __webpack_public_path__ + "img/596.1d45765d.jpg";